module.exports = __webpack_public_path__ + "static/family-health-0003cce752b7e9d31bf56ce32a0c90b9.png";